import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import BrowseButton from "../../components/BrowseButton";
import "react-datepicker/dist/react-datepicker.css";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import {
  getThanas,
  getAreas,
  getList,
} from "../../services/baseServices";
import moment from "moment";
import TimeRange from "react-time-range";
import MetaInfo from '../../components/MetaInfo'

function PartnerForm(props) {
  const [schedule, setSchedule] = useState(props.formData?.schedule);
  const [addressLine, setAddressLine] = useState(props.formData?.address_line);
  const [route, setRoute] = useState(props.formData?.route_id);
  const [status, setStatus] = useState(props.formData?.status || "");
  const [areas, setAreas] = useState([]);
  const [thanas, setThanas] = useState([]);
  const [distributor, setDistributor] = useState(props.formData.distributor_id || '');
  const [routes, setRoutes] = useState([]);

  const [workHours, setWorkHours] = useState([
    { opening_time: moment(), closing_time: moment().add(4, "hours") },
    { opening_time: moment(), closing_time: moment().add(4, "hours") },
    { opening_time: moment(), closing_time: moment().add(4, "hours") },
    { opening_time: moment(), closing_time: moment().add(4, "hours") },
    { opening_time: moment(), closing_time: moment().add(4, "hours") },
    { opening_time: moment(), closing_time: moment().add(4, "hours") },
    { opening_time: moment(), closing_time: moment().add(4, "hours") },
  ]);

  const [work_days, setWorkDays] = useState([
    {
      day_index: 0,
      is_opened: true,
      opening_time: moment().format("HH:mm"),
      closing_time: moment().add(4, "hours").format("HH:mm"),
      validTime: true,
    },
    {
      day_index: 1,
      is_opened: true,
      opening_time: moment().format("HH:mm"),
      closing_time: moment().add(4, "hours").format("HH:mm"),
      validTime: true,
    },
    {
      day_index: 2,
      is_opened: true,
      opening_time: moment().format("HH:mm"),
      closing_time: moment().add(4, "hours").format("HH:mm"),
      validTime: true,
    },
    {
      day_index: 3,
      is_opened: true,
      opening_time: moment().format("HH:mm"),
      closing_time: moment().add(4, "hours").format("HH:mm"),
      validTime: true,
    },
    {
      day_index: 4,
      is_opened: true,
      opening_time: moment().format("HH:mm"),
      closing_time: moment().add(4, "hours").format("HH:mm"),
      validTime: true,
    },
    {
      day_index: 5,
      is_opened: true,
      opening_time: moment().format("HH:mm"),
      closing_time: moment().add(4, "hours").format("HH:mm"),
      validTime: true,
    },
    {
      day_index: 6,
      is_opened: true,
      opening_time: moment().format("HH:mm"),
      closing_time: moment().add(4, "hours").format("HH:mm"),
      validTime: true,
    },
  ]);

  const callThanas = (distributor_id) => {
    getThanas({ distributor_id: distributor_id })
      .then((res) => {
        setThanas(res);
      })
      .catch((errMsg) => {});
  };

  const callAreas = (thana_id) => {
    getAreas({ thana_id: thana_id })
      .then((res) => {
        setAreas(res);
      })
      .catch((errMsg) => {});
  };

  useEffect(() => {
    setSchedule(props.formData.schedule);
    setAddressLine(props.formData.address_line);
    setRoute(props.formData.route_id);
    setStatus(props.formData.status);
    props.handleServiceHourOnChange("work_days", work_days);
    getList("routes")
      .then((res) => {
        setRoutes(res);
      })
      .catch((errMsg) => {});
  }, []);

  useEffect(()=>{
    if(props.formData.route_id) {
      setRoute(props.formData.route_id);
      const xxx = routes?.find(i=> i.id === parseInt(props.formData.route_id))?.distributor_id
      setDistributor(xxx)
      props.setDistributorId(xxx)
    }
  }, [props.formData.route_id])

  useEffect(() => {
    if(props.formData.distributor_id)
      callThanas(props.formData.distributor_id);
  }, [props.formData.distributor_id]);

  // useEffect(() => {
  //   callThanas(distributor);
  // }, [distributor]);

  useEffect(() => {
    if (props.formData.thana_id !== undefined)
      callAreas(props.formData.thana_id);
  }, [props.formData.thana_id]);

  useEffect(() => {
    if (props.formData.address_line !== undefined)
      setAddressLine(props.formData.address_line);
  }, [props.formData.address_line]);

  useEffect(() => {
    let formattedWorkDays = [];
    let clonedWorkHours = [...workHours];
    props.formData.work_days !== undefined &&
      props.formData.work_days.forEach((wd, i) => {
        if (wd.is_opened === true || wd.is_opened === "true") {
          formattedWorkDays.push({
            day_index: i,
            is_opened: true,
            opening_time: wd.opening_time,
            closing_time: moment(wd.closing_time, "HH:mm").format("HH:mm"),
            validTime: true,
          });

          clonedWorkHours[i].opening_time = moment(wd.opening_time, "HH:mm");
          clonedWorkHours[i].closing_time = moment(wd.closing_time, "HH:mm");
        } else {
          formattedWorkDays.push({
            day_index: i,
            is_opened: false,
            opening_time: moment().format("HH:mm"),
            closing_time: moment().add().add(4, "hours").format("HH:mm"),
            validTime: true,
          });
        }
      });
    setWorkHours(workHours);
    setWorkDays(formattedWorkDays);
  }, [props.formData.work_days]);

  function checkDate(start, end) {
    const mStart = moment(start);
    const mEnd = moment(end);
    return mStart.isBefore(mEnd);
  }

  const serviceHourHandler = (event, i) => {
    console.log("109", event);
    let clonedWorkDays = [...work_days];
    let clonedWorkHours = [...workHours];
    clonedWorkHours[i].opening_time = event.startTime;
    clonedWorkHours[i].closing_time = event.endTime;
    clonedWorkDays[i].opening_time = moment(event.startTime).format("HH:mm");
    clonedWorkDays[i].closing_time = moment(event.endTime).format("HH:mm");
    clonedWorkDays[i].validTime = checkDate(event.startTime, event.endTime);
    setWorkDays(clonedWorkDays);
    setWorkHours(clonedWorkHours);
    props.handleServiceHourOnChange("work_days", clonedWorkDays);
  };

  const closeDayHandler = (event, i) => {
    console.log(event.target.checked, i);
    let clonedWorkDays = [...work_days];
    let clonedWorkHours = [...workHours];
    clonedWorkDays[i].is_opened = !event.target.checked;
    clonedWorkHours[i].opening_time = moment();
    clonedWorkHours[i].closing_time = moment().add(4, "hours");
    clonedWorkDays[i].opening_time = moment().format("HH:mm");
    clonedWorkDays[i].closing_time = moment().add(4, "hours").format("HH:mm");
    clonedWorkDays[i].validTime = true;
    console.log("after", clonedWorkDays[i]);
    setWorkDays(clonedWorkDays);
    setWorkHours(clonedWorkHours);
    props.handleServiceHourOnChange("work_days", clonedWorkDays);
  };

  return (
    <Form noValidate onSubmit={props.handleClick}>
      <div className="card-block">
        <div className="block-header">
          <h4 className="block-title">Basic Info</h4>
        </div>
        <div className="block-body">
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Route <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                required
                name="route_id"
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                value={route}
                as="select"
                type="text"
              >
                <option value="">--Select--</option>
                {routes.length > 0
                  ? routes.map((item,i) => {
                      return (
                        <option
                          key={i}
                          value={item.id}
                          selected={props.formData.route_id === item.id}
                        >
                          {item.title}
                        </option>
                      );
                    })
                  : ""}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Please select Route.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column sm="3">Distributor</Form.Label>
                <Col sm="9" md={8} lg={7}>
                  <Form.Control
                    readOnly
                    defaultValue={routes?.find(i=> i.id === parseInt(route))?.distributor_name}
                    required
                    type="text"/>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="3">Business Type<span className="text-danger">*</span></Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <label className="sr-only">Business Type</label>
                     <select id="business_type" name="business_type" className='form-control' onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                            value={props.formData.business_type}>
                        <option value="">--Select--</option>
                        <option value={'b2c'} selected={props.formData.business_type === 'b2c'}>B2C</option>
                        <option value={'b2b'} selected={props.formData.business_type === 'b2b'}>B2B</option>
                        <option value={'both'} selected={props.formData.business_type === 'both'}>Both</option>
                    </select>
                </Col>
            </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="3">Schedule<span className="text-danger">*</span></Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <label className="sr-only">Schedule</label>
                     <select id="schedule" name="schedule" className='form-control' onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                            value={schedule}>
                        <option value="">--Select--</option>
                        <option value={'sat_mon_wed'} selected={props.formData.schedule === 'sat_mon_wed'}>SAT-MON-WED</option>
                        <option value={'sun_tues_thurs'} selected={props.formData.schedule === 'sun_tues_thurs'}>SUN-TUES-THURS</option>
                        <option value={'sat_sun_mon_tues_wed_thurs'} selected={props.formData.schedule === 'sat_sun_mon_tues_wed_thurs'}>SAT-SUN-MON-TUES-WED-THURS</option>
                    </select>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm="3">Commission Applicable<span className="text-danger">*</span></Form.Label>
              <Col sm="9" md={8} lg={7}>
              <label className="sr-only">Commission Applicable</label>
              <select id="schedule" name="is_commission_applicable" className='form-control' onChange={props.handleInputOnChange} value={props.formData?.is_commission_applicable}>
                <option value="">--Select--</option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="displayOrShopName">
                <Form.Label column sm="3">Outlet Name (English)<span className="text-danger">*</span>
                </Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <Form.Control
                        name={"name"}
                        onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                        defaultValue={props.partnerInfo.name}
                        required
                        type="text"/>
                    <Form.Control.Feedback type="invalid">Please enter name.</Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="displayOrShopName">
                <Form.Label column sm="3">Outlet Name (Bangla)<span className="text-danger">*</span>
                </Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <Form.Control
                        name={"bn_name"}
                        onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                        defaultValue={props.partnerInfo.bn_name}
                        required
                        type="text"/>
                    <Form.Control.Feedback type="invalid">Please enter bangla name.</Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formName">
                <Form.Label column sm="3">
                    Slug <span className="text-danger">*</span>
                </Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <Form.Control type="text"
                                    required
                                    onChange={e => {
                                        props.handleInputOnChange(e);
                                    }}
                                    value={props.formData.slug}
                                    name="slug" />
                    <Form.Control.Feedback type="invalid">
                        Please provide a slug.
                    </Form.Control.Feedback>
                    {props.uniqueSlug === false && <div class="slug-err-msg">Please provide an unique slug.</div>}
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="displayOrShopName">
                <Form.Label column sm="3">
                    Phone <span className="text-danger">*</span>
                </Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <Form.Control
                        name={"phone"}
                        autoComplete="new-phone" autoCorrect="off"
                        onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                        defaultValue={props.partnerInfo.phone}
                        required
                        pattern="(^([+]{1}[8]{2}|0088)?(01){1}[3-9]{1}\d{8})$"
                        type="text"/>
                    <Form.Control.Feedback type="invalid">Please enter phone no.</Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="displayOrShopName">
          <Form.Label column sm="3">
            Email <span className="text-danger">*</span>
          </Form.Label>
          <Col sm="9" md={8} lg={7}>
          <Form.Control
            name={"email"}
            onChange={e => {
                            props.handleInputOnChange(e);
                        }}
            defaultValue={props.partnerInfo.email}
            type="text"/>
          </Col>
        </Form.Group> 
            <Form.Group as={Row} controlId="displayOrShopName">
                <Form.Label column sm="3">
                    Password {props.isCreateForm && <span className="text-danger">*</span>}
                </Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <Form.Control
                        name={"password"}
                        autoComplete="new-password" autoCorrect="off"
                        onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                        type="password"/>
                    {props.partnerInfo?.password_presence &&
                    <i className="text-help text-muted text-danger">Please keep this field blank if you don't want to
                        change the password.</i>}
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="displayOrShopName">
                <Form.Label column sm="3">
                    Confirm Password {props.isCreateForm && <span className="text-danger">*</span>}
                </Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <Form.Control
                        name={"password_confirmation"}
                        autoComplete="new-password" autoCorrect="off"
                        onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                        type="password"/>
                    {props.partnerInfo?.password_presence &&
                    <i className="text-help text-muted text-danger">Please keep this field blank if you don't want to
                        change the password.</i>}
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label column sm="3">Status</Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <RadioGroup row name="status" value={status} onChange={e => {
                            props.handleInputOnChange(e);
                        }}>
                        <FormControlLabel value={'active'} control={<Radio/>} label="Active" checked={props.formData.status === 'active'}/>
                        <FormControlLabel value={'inactive'} control={<Radio/>} label="Inactive" checked={props.formData.status === 'inactive'}/>
                    </RadioGroup>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="displayOrShopName">
                <Form.Label column sm="3">
                    TSA Id
                </Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <Form.Control
                        name={"tsa_id"}
                        onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                        defaultValue={props.partnerInfo.tsa_id}
                        type="text"/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="displayOrShopName">
                <Form.Label column sm="3">
                    Retailer Code
                </Form.Label>
                <Col sm="9" md={8} lg={7}>
                    <Form.Control
                        name={"retailer_code"}
                        onChange={e => {
                            props.handleInputOnChange(e);
                        }}
                        defaultValue={props.partnerInfo.retailer_code}
                        type="text"/>
                </Col>
            </Form.Group>

          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              <span className="text-danger">*</span>
              Partner Code
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"partner_code"}
                required
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.partner_code}
                type="text"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Region
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"region"}
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.region}
                type="text"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Territory
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"territory"}
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.territory}
                type="text"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Point
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"point"}
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.point}
                type="text"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Owner Name
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"owner_name"}
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.owner_name}
                type="text"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Cluster Name
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"cluster_name"}
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.cluster_name}
                type="text"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Sub Channel
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"sub_channel"}
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.sub_channel}
                type="text"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Latitude
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"latitude"}
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.latitude}
                type="number"
                step="any"
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Longitude
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                name={"longitude"}
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={props.partnerInfo.longitude}
                type="number"
                step="any"
              />
            </Col>
          </Form.Group>

          {/* <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              District <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                required
                name="district_id"
                onChange={(e) => {
                  callThanas(e.target.value);
                  props.handleInputOnChange(e);
                }}
                value={props.formData.district_id}
                as="select"
                type="text"
              >
                <option value="">--Select District--</option>
                {districts.length > 0
                  ? districts.map((item) => {
                      return (
                        <option
                          value={item.id}
                          selected={props.formData.district_id === item.id}
                        >
                          {item.name}
                        </option>
                      );
                    })
                  : ""}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Please enter address.
              </Form.Control.Feedback>
            </Col>
          </Form.Group> */}

          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Thana <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                required
                name="thana_id"
                onChange={(e) => {
                  callAreas(e.target.value);
                  props.handleInputOnChange(e);
                }}
                value={props.formData.thana_id}
                as="select"
                type="text"
              >
                <option value="">--Select Thana--</option>
                {thanas.length > 0
                  ? thanas.map((item) => {
                      return (
                        <option
                          value={item.id}
                          selected={props.formData.thana_id === item.id}
                        >
                          {item.name}
                        </option>
                      );
                    })
                  : ""}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Please enter address.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Area <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                required
                name="area_id"
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                as="select"
                type="text"
                value={props.formData.area_id}
              >
                <option value="">--Select Area--</option>
                {areas.length > 0
                  ? areas.map((item) => {
                      return (
                        <option
                          value={item.id}
                          selected={props.formData.area_id === item.id}
                        >
                          {item.name}
                        </option>
                      );
                    })
                  : ""}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                Please enter address.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="displayOrShopName">
            <Form.Label column sm="3">
              Address<span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <Form.Control
                required
                name="address_line"
                onChange={(e) => {
                  props.handleInputOnChange(e);
                }}
                defaultValue={addressLine}
                as="textarea"
                type="text"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                Please enter address.
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formImages">
            <Form.Label column sm="3">
              Image
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              <BrowseButton
                onChange={(e) => {
                  props.handleInputOnChange({
                    target: { name: "image_file", value: e.target.files[0] },
                  });
                }}
                id={"imageFile"}
                name={"image_file"}
              />
              {props.partnerInfo.image && (
                <div className="existing-images">
                  <div className="existing-img">
                    <span className="btn-remove">×</span>
                    <img src={props.partnerInfo.image} alt="" />
                  </div>
                </div>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="serviceHr">
            <Form.Label column sm="3">
              Service Hours<span className="text-danger">*</span>
            </Form.Label>
            <Col sm="9" md={8} lg={7}>
              {work_days.map((day, i) => {
                let nameOfDay;
                switch (i) {
                  case 0:
                    nameOfDay = "Sunday";
                    break;
                  case 1:
                    nameOfDay = "Monday";
                    break;
                  case 2:
                    nameOfDay = "Tuesday";
                    break;
                  case 3:
                    nameOfDay = "Wednesday";
                    break;
                  case 4:
                    nameOfDay = "Thursday";
                    break;
                  case 5:
                    nameOfDay = "Friday";
                    break;
                  case 6:
                    nameOfDay = "Saturday";
                    break;
                }

                return (
                  <>
                    <b>{nameOfDay || ""}</b>
                    <div>
                      <TimeRange
                        className={
                          !work_days[i].is_opened ? "disableServiceHr" : ""
                        }
                        onChange={(event) => serviceHourHandler(event, i)}
                        startMoment={workHours[i].opening_time}
                        endMoment={workHours[i].closing_time}
                        startLabel="Start:"
                        endLabel="End:"
                        use24Hours
                        minuteIncrement={1}
                        sameIsValid={false}
                      />
                      <input
                        type="checkbox"
                        checked={!work_days[i].is_opened}
                        onChange={(event) => closeDayHandler(event, i)}
                      />{" "}
                      Mark as Close day
                    </div>
                    <hr />
                  </>
                );
              })}
            </Col>
          </Form.Group>
        </div>
      </div>
      <div className="card-block">
        <div className="block-header">
          <h4 className="block-title">Meta Info</h4>
        </div>
        <div className="block-body">
          <MetaInfo
            metaInfo={props.metaInfo}
            handleOnInputChange={props.handleOnMetaInputChange}
            handleOnChangeKeywordValue={props.handleOnChangeKeywordValue}
          />
        </div>
      </div>

      <div className="mt-3 text-right">
        <Button
          size="lg"
          type={`submit`}
          disabled={props.isSubmitting || !props.readyToSubmit || props.uniqueSlug === false}
          variant="primary"
        >
          {props.isSubmitting ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </Form>
  );
}

export default PartnerForm;
